import { Component, EventEmitter, Input, NgModule, OnInit, Output, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CommonReportDictionaryItem, ReportFilterChange } from '../../models/report-filters.model';
import { CheckboxGroupFilterComponentModule, CheckboxGroupFilterComponent } from '../checkbox-group-filter/checkbox-group-filter.component';
import { ReportFiltersHelperService } from '../../services/report-filters-helper.service';
import { ReportDictionariesService } from '../../services/report-dictionaries.service';

@Component({
  selector: 'stx-report-exclusions-filter',
  templateUrl: './report-exclusions-filter.component.html',
  imports: [CheckboxGroupFilterComponent]
})
export class ReportExclusionsFilterComponent implements OnInit {
  private reportFiltersHelperService = inject(ReportFiltersHelperService);
  private reportDictionariesService = inject(ReportDictionariesService);

  @Input() formGroupReference: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<ReportFilterChange>();

  dictionaryOptions: CommonReportDictionaryItem[];

  ngOnInit(): void {
    this.dictionaryOptions = this.reportFiltersHelperService.getCheckboxGroupOptionsFromDictionary(
      this.reportDictionariesService.dictionaries.exclusions
    );

    this.reportFiltersHelperService.addCheckboxGroupOptionsToFormGroup(this.formGroupReference, this.dictionaryOptions);
  }

  onFilterChange($event: ReportFilterChange) {
    this.filterChange.emit($event);
  }
}

@NgModule({
  imports: [CheckboxGroupFilterComponentModule, ReportExclusionsFilterComponent],
  exports: [ReportExclusionsFilterComponent]
})
export class ReportExclusionsFilterComponentModule {}
